import ProposalForm from "@/components/ProposalForm";
import { FormProvider } from "@/contexts/proposalFormContext";

export default function ProposalWrapper() {
    return (
        <FormProvider>
          <ProposalForm />
        </FormProvider>
      );
}